<template>
  <template v-for="(part, partIndex) in listParts" :key="partIndex">
    <span v-if="part.type === 'literal'">{{ part.value }}</span>
    <slot
      v-else
      :item="part.item ?? part.value"
      :index="part.itemIndex ?? 0"
    >
      {{ part.item ?? part.value }}
    </slot>
  </template>
</template>

<script setup lang="ts">
import { andListJoiner, orListJoiner } from '@/i18n';
import { computed } from 'vue';

type IntlListFormatPart = ReturnType<Intl.ListFormat['formatToParts']>[number];

type LocalizedListPart = IntlListFormatPart & {
  itemIndex?: number;
  item?: string;
};

const props = withDefaults(defineProps<{
  items: string[];
  joiner?: 'and' | 'or';
}>(), {
  joiner: 'and'
});

const listFormatter = computed(() => {
  return props.joiner === 'and' ? andListJoiner.value : orListJoiner.value;
});

const listParts = computed<LocalizedListPart[]>(() => {
  if (props.items.length === 0) return [];

  const parts = listFormatter.value.formatToParts(props.items);
  let elementIndex = 0;

  return parts.map((part) => {
    if (part.type !== 'element') return part;

    const itemIndex = elementIndex++;
    return {
      ...part,
      itemIndex,
      item: props.items[itemIndex]
    };
  });
});
</script>